var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-footer"},[_vm._v(" Copyright © 2021 大愿科技 网站备案：琼ICP备2021007209号-1 琼B2-20210969号 客服：service@dayuan1997.com ")])
}
var staticRenderFns = []

export { render, staticRenderFns }